import React from "react";
import { Chip, Stack } from "@mui/material";

import { JOB_STATUSES } from "../../constants";

const flow = {
  [JOB_STATUSES.NOT_STARTED]: { color: "grey" },
  [JOB_STATUSES.IN_PROGRESS]: { color: "blue" },
  [JOB_STATUSES.COMPLETE]: { color: "green" },
};
const sx = {
  "& .MuiChip-label": {
    fontSize: 10,
    fontWeight: 500,
  },
  my: "-4px",
};

const OutsideProcessingVendorStatusChip = ({ item }) => {
  const label = JOB_STATUSES.NOT_STARTED;
  const final = flow[label];

  return (
    <Stack direction="row" gap="5px">
      <Chip
        label={"Not Started" || item?.status}
        variant="colorTag"
        flow={final.color}
        sx={sx}
      />
    </Stack>
  );
};

export default OutsideProcessingVendorStatusChip;
